import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FalkeTekLogo } from "../components/Brand";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";

export default function Impressum() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    // Public endpoint — falls eingeloggt mit Auth, sonst ohne
    api.get("/public/company-info").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-falke-warmwhite" data-testid="impressum-page">
      <header className="px-6 py-5 bg-white border-b border-falke-blue/10">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <FalkeTekLogo />
          <Link to="/" className="text-falke-blue/70 hover:text-falke-orange inline-flex items-center gap-1 text-sm">
            <ArrowLeft size={14} /> Zurück
          </Link>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-4xl font-heading font-bold text-falke-blue mb-8">Impressum</h1>

        <section className="space-y-3 text-falke-anthracite/85">
          <p className="text-lg font-semibold text-falke-blue">{info?.firmenname || "FalkeTek GmbH"}</p>
          <p>{info?.firmenadresse || "Friedrich-Ebert-Straße 123, 52531 Übach-Palenberg"}</p>
          <p>Internet: <a href="https://www.falke-tek.de" className="text-falke-orange hover:underline">www.falke-tek.de</a></p>
          <p>E-Mail: <a href={`mailto:${info?.email || "info@falke-tek.de"}`} className="text-falke-orange hover:underline">{info?.email || "info@falke-tek.de"}</a></p>
          <p>Telefon: {info?.telefon || "+49 2451 9329167"}</p>
        </section>

        <hr className="my-8 border-falke-blue/10" />

        <section className="space-y-2 text-falke-anthracite/85">
          <h2 className="text-xl font-heading text-falke-blue mb-3">Handelsregister</h2>
          <p>{info?.hrb || "Amtsgericht Aachen HRB 28242"}</p>
        </section>

        <hr className="my-8 border-falke-blue/10" />

        <section className="space-y-2 text-falke-anthracite/85">
          <h2 className="text-xl font-heading text-falke-blue mb-3">Steuerangaben</h2>
          <p>Umsatzsteuer-ID: <span className="font-mono">{info?.ust_id_nr || "DE450200940"}</span></p>
          {info?.steuernummer && <p>Steuernummer: <span className="font-mono">{info.steuernummer}</span></p>}
        </section>

        <hr className="my-8 border-falke-blue/10" />

        <section className="space-y-2 text-falke-anthracite/85">
          <h2 className="text-xl font-heading text-falke-blue mb-3">Geschäftsführung</h2>
          <p>{info?.geschaeftsfuehrer || "Deniz Sahin, Yavuz-Selim Cifcibasi, Kevin Schunk"}</p>
        </section>

        <hr className="my-8 border-falke-blue/10" />

        <section className="space-y-2 text-falke-anthracite/85">
          <h2 className="text-xl font-heading text-falke-blue mb-3">Verantwortlich für den Inhalt (§ 18 Abs. 2 MStV)</h2>
          <p>{info?.geschaeftsfuehrer?.split(",")[0]?.trim() || "Deniz Sahin"}<br />
            {info?.firmenadresse || "Friedrich-Ebert-Straße 123, 52531 Übach-Palenberg"}</p>
        </section>

        <hr className="my-8 border-falke-blue/10" />

        <section className="space-y-2 text-falke-anthracite/85">
          <h2 className="text-xl font-heading text-falke-blue mb-3">Hinweis zur Online-Streitbeilegung</h2>
          <p className="text-sm">
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung bereit:{" "}
            <a href="https://ec.europa.eu/consumers/odr" className="text-falke-orange hover:underline" target="_blank" rel="noreferrer">https://ec.europa.eu/consumers/odr</a>.
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>

        <div className="mt-10 text-center">
          <Link to="/datenschutz" className="text-falke-orange hover:underline mr-6" data-testid="link-datenschutz">Datenschutz</Link>
          <Link to="/" className="text-falke-blue/70 hover:text-falke-orange">Zurück zur App</Link>
        </div>
      </div>
    </div>
  );
}
